export default "__VITE_ASSET__BGdHoTdf__"